let initialState = {
  mentionPageData: { data: null, page: 1, limit: 10 },
  infoLoader: true,
  tabLoader: false,
  deepDiveInfobar: null,
  deepDiveResponse: [],
  detailedInsightObj: null,
  isDetailedInsightVisible: {
    value: false,
    tab_id: null,
    name: "Mentions",
    key: "1",
  },
  filter: {
    type: "",
    name: "",
    attribute: "",
    datatype: "",
  },
  datatype: {
    primaryType: "",
    secondaryType: "",
  },
  sorting: { value: "Engagement", sortOrder: "High - Low" },
  widgetLoaders: {},
  tabClick: { tabName: null, state: false },
  mentioninnertabs: false,
  mentionTabsNews: false,
  deepDiveFlag: false,
};
const DeepDive = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MENTION_PAGE_DATA":
      return {
        ...state,
        mentionPageData: action.payload,
      };
    case "SET_INFO_LOADER":
      return {
        ...state,
        infoLoader: action.payload,
      };
    case "SET_TAB_LOADER":
      return {
        ...state,
        tabLoader: action.payload,
      };
    case "SET_CLEAR_DEEP_DIVE":
      return {
        ...state,
        deepDiveResponse: action.payload,
      };
    case "SET_DETAILED_INSIGHT_OBJ":
      return {
        ...state,
        detailedInsightObj: action.payload,
      };
    case "SET_DETAILED_INSIGHT_MODAL":
      return {
        ...state,
        isDetailedInsightVisible: action.payload,
      };
    case "SET_TAB_CLICK":
      return {
        ...state,
        tabClick: action.payload,
      };
    case "SET_DEEP_DIVE_INFOBAR":
      return {
        ...state,
        deepDiveInfobar: action.payload,
      };
    case "SET_DEEP_DIVE_TAB_RESPONSE":
      return {
        ...state,
        deepDiveResponse: action.payload,
      };
    case "SET_DEEP_DIVE_FILTER":
      return {
        ...state,
        filter: action.payload,
      };

    case "SET_DATATYPE":
      return {
        ...state,
        datatype: action.payload,
      };
    case "SET_MENTION_SORTING":
      return {
        ...state,
        sorting: action.payload,
      };
    case "SET_MENTION_PAGE_INNER_TABS":
      return {
        ...state,
        mentioninnertabs: action.payload,
      };
    case "SET_MENTION_TABS_NEWS":
      return {
        ...state,
        mentionTabsNews: action.payload,
      };
    case "SET_DEEPDIVE_WIDGET_LOADERS":
      return {
        ...state,
        widgetLoaders: action.payload,
      };
    case "SET_DEEP_DIVE_FLAG":
      return {
        ...state,
        deepDiveFlag: action.payload,
      };
    default:
      return state;
  }
};

export default DeepDive;
